import React from 'react';
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import chart_img from '../../../assets/images/icons/user-dashboard/chart.png';

const DashboardHomeView = (props) => {
  // if (localStorage.getItem("token")) {
  return (
    <>
      <div className="dashboard-body-area">
        <section className="findjob-search-section">
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-md-3 findjob-search-heading">
                <h2 className="cc-main_title--md">Find a job</h2>
              </div>
              <div className="col-md-8 findjob-search-bar">
                <div className="cc-searchbar">
                  <div className="srch-fld-row">
                    <div className="srch-fld-col">
                      <input type="text" placeholder="Postcode" />
                    </div>
                    <div className="srch-fld-col">
                      <select>
                        <option>Select Profession</option>
                        <option>Doctor</option>
                      </select>
                    </div>
                    <div className="srch-fld-col srch-btn-col">
                      <input
                        type="submit"
                        value=""
                        className="form-submit-btn"
                      />
                    </div>
                  </div>
                </div>
                <h5 className="job-search-info">
                  List of Jobs will apear based on the postcode given by user
                </h5>
              </div>
            </div>
          </div>
        </section>

        <div className="dashboard-quicklink-box-area">
          <div className="row">
            <div className="col-lg-4">
              <div className="dshboard-quicklink-box">
                <h3 className="box-title">Profile Completeness</h3>
                <div className="chart-area">
                  <img src={chart_img} alt="" />
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="dshboard-quicklink-box">
                <h3 className="box-title">Profile Views</h3>
                <div className="mid-count-area">
                  <div className="big-blue-text">0</div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="dshboard-quicklink-box">
                <h3 className="box-title">Jobs Posted</h3>
                <div className="mid-count-area">
                  <div className="big-blue-text">{props.jobs_posted_count}</div>
                </div>
                <div className="box-action-row">
                  <a href="/dashboard/posted-job" className="dashbrd-text-btn">
                    VIEW ALL
                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="dshboard-quicklink-box">
                <h3 className="box-title">Applied Jobs</h3>
                <div className="mid-count-area">
                  <div className="big-blue-text">{props.applied_counts}</div>
                </div>
                <div className="box-action-row">
                  <a href="/dashboard/applied-job" className="dashbrd-text-btn">
                    VIEW ALL
                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="dshboard-quicklink-box highlight">
                <h3 className="box-title"> Accepted Job</h3>
                <div className="mid-count-area">
                  <div className="big-blue-text">0</div>
                </div>
                <div className="box-action-row">
                  <a
                    href="/dashboard/accepted-job"
                    className="dashbrd-text-btn"
                  >
                    VIEW ALL
                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="dshboard-quicklink-box">
                <h3 className="box-title">Saved Job(s)</h3>
                <div className="mid-count-area">
                  <div className="big-blue-text">0</div>
                </div>
                <div className="box-action-row">
                  <a href="" className="dashbrd-text-btn">
                    VIEW ALL
                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  // } else {
  //     return (
  //       <Navigate to="/login" />
  //     )
  //   }
};

export default DashboardHomeView;
